import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './core/analytics-service/analytics.service';
import { environment } from '../environments/environment';
import { CheckForUpdateService } from './core/check-for-update-service/check-for-update.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(
    private updates: CheckForUpdateService,
    private analyticsService: AnalyticsService,
  ) {}

  ngOnInit(): void {
    this.updates.init();
    this.analyticsService.load({ enabled: environment.production });
  }
}
